export const unitsOptionsList = [
  { value: 'tbs', label: 'tbs' },
  { value: 'tsp', label: 'tsp' },
  { value: 'kg', label: 'kg' },
  { value: 'g', label: 'g' },
  { value: 'pcs', label: 'pcs' },
];
